module.exports = __webpack_public_path__ + "static/media/star.ec66e9c7.svg";